import { useMemo } from 'react';
import { buildSrcDoc } from '../../lib/mailHtml';

/**
 * The only place message HTML is ever rendered. `sandbox=""` applies every restriction:
 * no scripts, no same-origin (opaque origin, so no access to portal cookies, storage or
 * DOM), no forms, no popups, no top navigation. The CSP meta in the srcdoc backs that up
 * and limits images to data: unless the user opted in to remote ones.
 *
 * Height cannot be measured without allow-same-origin, so the frame has a fixed,
 * user-resizable height and scrolls internally.
 */
export function MailHtmlFrame({
  html,
  allowRemoteImages,
  title,
}: {
  html: string;
  allowRemoteImages: boolean;
  title: string;
}) {
  const srcDoc = useMemo(() => buildSrcDoc(html, allowRemoteImages), [html, allowRemoteImages]);
  return (
    <iframe
      className="mail-html-frame"
      title={title}
      sandbox=""
      srcDoc={srcDoc}
      referrerPolicy="no-referrer"
      loading="lazy"
    />
  );
}
